import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import LiteraryWorksItemForm from "./LiteraryWorksItemForm";
import LiteraryWorksItemBrowser from "./LiteraryWorksItemBrowser";

const LiteraryWorksPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="literary_work"
            modeApiName2="literary_works"
            ItemFormComponent={LiteraryWorksItemForm}
            browserStyle={{width: "min(35%, 460px)", minWidth: "310px"}}
            ItemBrowserComponent={LiteraryWorksItemBrowser}
        />
    );
};

export default LiteraryWorksPage;